/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React from "react";
import SafeLink from "components/commons/SafeLink";

import styled, {css} from "styled-components";

import {
  useCheckMobileView,
  WealthyEnv
} from "helpers";

import ThankYou from "../commons/ThankYou";

const mobileImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-about-wealthy-mobile-image.svg`;
const highlightedStarImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-about-wealthy-highlighted-star.svg`;
const fadedStarImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-about-wealthy-faded-star.svg`;
const registerSuccessIcon = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-advisors-carousel-share-sucess-icon.svg`;

const InThePress = ({
  formData,
  activeTab,
  inThePressData,
  setActiveTab,
  showModal,
  onChangeHandler,
  submitHandler,
  setShowModal
}) => {
  const selectedTab = inThePressData.filter((option) => option.id === activeTab)[0];
  const isMobileView = useCheckMobileView();

  return (

    <Wrapper>
      <Title>In The Press</Title>
      <NewsArticlesImageWrapper>
        {
          inThePressData.map((tab) => {
            return (
              <li
                className={activeTab === tab.id ? "tab-title tab-title-active" : "tab-title"}
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
              >
                <EachArticle>
                  <img  alt="news-article-image" className="each-article" loading="lazy" src={tab.tabImageUrl} />
                </EachArticle>
              </li>
            );
          })
        }
      </NewsArticlesImageWrapper>
      <WealthyRaisesArticle id={`tab-content${selectedTab.id}`}>
        <Image className="news-image-container">
          <img alt="wealthy-in-news-image" className="each-detail-image" loading="lazy" src={selectedTab.detailImage} />
        </Image>
        <Content className="news-text-container" >
          <Header>
            {selectedTab.heading}
          </Header>
          <Description>
            {selectedTab.description}
          </Description>
        </Content>
      </WealthyRaisesArticle>
      <AboutWealthyContainer id="about-us">
        <AboutWealthyTitle>About Wealthy.in</AboutWealthyTitle>
        <AboutWealthyDescription>
          Founded by two IIT-IIM alums, <SafeLink
            className="founder-name"
            href="https://www.linkedin.com/in/prashant-gupta-1b884b6/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Prashant Gupta</SafeLink> and&nbsp;
          <SafeLink
            className="founder-name"
            href="https://www.linkedin.com/in/adagarwal/"
            rel="noopener noreferrer"
            target="_blank"
          >
              Aditya Agarwal</SafeLink>,
          Wealthy is committed to helping professionals grow their presence in Wealth Management. We are a bunch of passionate people operating at the intersection of technology and finance. In our efforts to deliver the best-in-class platform and deliver our promise, we have raised a total of INR 70 crore in our Series A funding.
        </AboutWealthyDescription>

        <GetOurAppContainer id="download-app">
          <PhoneImageContainer>
            <img alt="wealthy-partner-mobile-image" loading="lazy" src={mobileImage} />
          </PhoneImageContainer>
          <ContentContainer>
            <GetAppHeader>Get Wealthy Partners App</GetAppHeader>
            <GetAppDescription>
              We will send you a link, open it on your phone
              to download the app.

              <PhoneNumberInput>
                <PhoneNumberCode>+91</PhoneNumberCode>
                <Input
                  className="input--phone-number"
                  name="phoneNumber"
                  placeholder="Enter phone number"
                  type="number"
                  value={formData.phoneNumber}
                  onChange={onChangeHandler}
                />

                {
                  !isMobileView && (
                    <GetAppButton onClick={submitHandler}>
                    Get app link
                    </GetAppButton>

                  )
                }

              </PhoneNumberInput>

              {
                isMobileView && (
                  <GetAppButton isMobileView onClick={submitHandler}>
                    Get app link
                  </GetAppButton>
                )
              }

              {
                showModal && (
                  <ModalContainer>
                    <ModalContentContainer>
                      <Button onClick={() => setShowModal(false)}>
                        <span>+</span>
                      </Button>
                      <ThankYou
                        image={registerSuccessIcon}
                        primaryText="Thanks for showing interest"
                        secondaryText={`We will send the app download link via sms and whatsapp on ${formData.phoneNumber}`}
                      />
                    </ModalContentContainer>
                  </ModalContainer>
                )
              }

              <HowManyDownloadsContainer>
                50,000+ Downloads
                <span className="star-text-container">
                  4.5
                  <img alt="highlighted-star-image" className="highlighted-star" loading="lazy" src={highlightedStarImage} />
                  <img alt="highlighted-star-image" className="highlighted-star" loading="lazy" src={highlightedStarImage} />
                  <img alt="highlighted-star-image" className="highlighted-star" loading="lazy" src={highlightedStarImage} />
                  <img alt="highlighted-star-image" className="highlighted-star" loading="lazy" src={highlightedStarImage} />
                  <img alt="faded-star-image" className="faded-star" loading="lazy" src={fadedStarImage} />
                </span>
              </HowManyDownloadsContainer>

            </GetAppDescription>
          </ContentContainer>
        </GetOurAppContainer>
      </AboutWealthyContainer>
    </Wrapper>


  );
};


const ModalContainer = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background-color: #261E38;
  z-index: 999;
`;

const Button = styled.a`
  color: #fff;
  position: fixed;
  top: 20px;
  right: 30px;
  font-weight: 600;
  cursor: pointer;
  background-color: #ededed;
  border-radius: 50%;
  transform: rotate(45deg);
  font-size: 3rem;
  outline: 0;
  height: 3.6rem;
  width: 3.6rem;
  >span {
    position: absolute;
    right: 9px;
    top: -10px;
    color: #6c6c6c;
  }
  :hover {
    background-image: linear-gradient(to bottom,#efefef 0%,#f5f5f5 100%);
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  }
`;

const ModalContentContainer = styled.div`
  position: absolute;
  display: block;
  padding: 5rem;
  line-height: 1.8;
  width: 80rem;
  height: 58rem;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  box-shadow: 0px 12px 24px rgba(0,0,0,0.2);
  border-radius: 2.4rem;
  background-color: #f5f5f5;
  color: #34495E;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    height: 85%;
    padding: 4rem 2rem;
  }
`;

const Wrapper = styled.div`
  padding: 5rem 0 12rem;

  .active {
    transform: translateY(0);
    transition: all 1s ease;
    opacity: 1;
  }
`;

const GetAppButton = styled.div`
  width: 18rem;
  height: 5.6rem;
  flex-grow: 0;
  border-radius: 12px;
  background-color: #1c1c1c;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 1.8rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #f9f9f9;
  position: absolute;
  bottom: 7px;
  right: -5rem;
  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
    transform: scale(1.02);
  }

  @media (max-width: 768px) {
    ${props =>
    props.isMobileView &&
    css`
      position: relative;
      margin-left: -5rem;
      width: 95%;
      display: flex;
      justify-content: center;
      align-items: center;
    `}
  }
`;

const HowManyDownloadsContainer = styled.div`
  margin-top: 2.4rem;
  font-size: 2.4rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.75;
  letter-spacing: normal;
  text-align: left;
  color: #f9f9f9;
  display: flex;
  justify-content: center;

  .star-text-container {
    margin-left: 10rem;
    margin-right: 2rem;
  }
  .highlighted-star {
    margin-right: 0.5rem;
    &:first-child {
      margin-left: 1rem;
    }
  }

  @media (max-width: 768px) {
    font-size: 1.8rem;
    flex-direction: column;
    text-align: center;
    align-items: center;

    .star-text-container {
      margin: 1rem 0 0 0;
    }

    .highlighted-star {
    margin-right: 0.3rem;
    &:first-child {
      margin-left: 0.5rem;
    }
  }
  }
`;


const PhoneNumberInput = styled.div`
  position: relative;
  display: flex;
  width: 80%;
  margin-bottom: 4rem;
  .input--phone-number {
    position: relative;
    left: 7rem;
    border-left: none;
    border-bottom-left-radius: unset;
    border-top-left-radius: unset;
  }

  @media (max-width: 768px) {
    .input--phone-number {
      left: 5rem;
    }
  }
`;


const Input = styled.input`
  background-color: #fff;
  border-radius: 1.2rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0 2rem;
  color: #333;
  width: 100%;
  font-size: 1.5rem;
  font-weight: 400;
  display: block;
  height: 7rem;
  line-height: 1;
  margin-top: 8rem;

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::placeholder {
    color: #ccc;
    font-size: 1.6rem;
    text-align: left;
  }

  @media (max-width: 768px) {
    height: 4.5rem;
    width: 95%;
  }
`;

const PhoneNumberCode = styled.div`
  background: #fff;
  position: absolute;
  bottom: 0;
  height: 7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  width: 7rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-top-right-radius: unset !important;
  border-bottom-right-radius: unset !important;
  border-radius: 1.2rem;
  margin: 0 auto;
  color: #000;

  @media (max-width: 768px) {
    height: 4.5rem;
    width: 5rem;
  }
`;

const Title = styled.h3`
  text-align: center;
  font-family: MavenPro;
  font-size: 3.6rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000;

  @media (max-width: 768px) {
    font-size: 2.4rem;
  }
`;

const NewsArticlesImageWrapper = styled.div`
  width: 75%;
  margin: 8rem auto 4rem;
  display: flex;
  justify-content: space-between;
  overflow: scroll;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */

  ::-webkit-scrollbar {
    display: none;
  }

  .tab-title {
    list-style: none;
    cursor: pointer;
    transition: all 0.3s;
    margin-right: 2rem;
    :hover {
      transform: scale(1.05);
    }
  }

  @media (max-width: 768px) {
    width: 95%;
  }

`;

const EachArticle = styled.div`
  width: 18rem;

  .each-article {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  @media (max-width: 768px) {
    width: 14rem;
  }

`;

const WealthyRaisesArticle = styled.div`
  width: 75%;
  margin: 0 auto;
  padding: 4rem;
  border-radius: 2.4rem;
  border: solid 1px #e1e1e1;
  display: flex;

  @media (max-width: 768px) {
    width: 95%;
    flex-direction: column;
    padding: 4rem 2rem;
  }
`;

const Image = styled.div`
  height: 100%;

  .each-detail-image {
    width: 100%;
    object-fit: contain;
    border-radius: 1.2rem;
  }

  @media(max-width: 768px) {
    width: 100%;
  }

`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 4rem;
  width: 65%;

  @media (max-width: 768px) {
    width: 100%;
    margin: 2rem auto;
  }
`;

const Header = styled.h3`
  font-size: 2.4rem;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: #000;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const Description = styled.p`
  margin-top: 2rem;
  font-size: 1.8rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.78;
  letter-spacing: normal;
  text-align: left;
  color: #7e7e7e;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const AboutWealthyContainer = styled.div`
  width: 75%;
  margin: 10rem auto 0;

  @media (max-width: 768px) {
    width: 100%;
    margin: 8rem auto 0;
  }
`;

const AboutWealthyTitle = styled(Title)`
  font-size: 3.6rem;
  color: #1c1c1c;

  @media (max-width: 768px) {
    font-size: 2.4rem;
  }
`;

const AboutWealthyDescription = styled(Description)`
  font-size: 2.4rem;
  padding: 0 4rem;
  line-height: 1.75;
  font-weight: 100;
  text-align: center;

  margin: 4rem auto 8rem;
  .founder-name {
    font-weight: bold;
    text-decoration: underline;
    color: #1c1c1c;
    font-size: 2.4rem;
  }

  @media (max-width: 768px) {
    font-size: 1.8rem;
    padding: 0 2rem;

    .founder-name {
      font-size: 1.8rem;
    }

  }
`;

const GetOurAppContainer = styled.div`
  padding: 7.2rem 10rem 5rem;
  border-radius: 2.4rem;
  background-color: #6725f4;
  display: flex;

  @media (max-width: 768px) {
    width: 95%;
    margin: 0 auto;
    padding: 2rem 5rem;
  }
`;

const PhoneImageContainer = styled.div`
  width: 22rem;
  margin-right: 10rem;
  >img {
    object-fit: contain;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 4rem;
`;

const GetAppHeader = styled(Header)`
  font-size: 3.6rem;
  font-weight: 600;
  line-height: normal;
  color: #f9f9f9;

  @media (max-width: 768px) {
    font-size: 2.4rem;
  }

`;

const GetAppDescription = styled(Description)`
  font-size: 2.4rem;
  line-height: 1.75;
  color: #f9f9f9;
  margin: 2rem auto 7.8rem;
  max-width: 570px;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

export default InThePress;
